<template>
  <div></div>
</template>

<script>
import EventBus from '@/eventBus'
import VueToastedUtils from '@/utils/vue-toasted.utils.js'

export default {
  data() {
    return {
      currentToast: null,
    }
  },
  mounted() {
    EventBus.$on('import-convert-io: close_importing_toast', () => {
      if (this.currentToast) {
        this.currentToast.goAway(0)
      }
    })
    this.currentToast = VueToastedUtils.showToast(this.$i18nPresenter.t('Importing presentation…'), {}, {
      className: 'custom-toast__loading',
      hasReturnValue: true,
      action: {
        text: this.$i18nPresenter.t('View'),
        class: 'custom-toast__loading-url',
        onClick: () => {
          if (this.$store.state.openImportModal) return
          this.$store.state.openImportModal = true
        },
      },
    })
  },
  destroyed() {
    EventBus.$off('import-convert-io: close_importing_toast')
  },
}
</script>

<style>
.custom-toast__loading.toasted.bubble {
  color: #257ADC;
  background-color: #F2F7FF !important;
  border: 1px solid #348EF6;
  border-radius: 4px;
  &::before {
    content: "";
    animation: spin 1s linear infinite;
    display: inline-block;
    border-radius: 100%;
    height: 1rem;
    width: 1rem;
    border: 2px solid rgba(52, 142, 246, 0.3);
    border-top-color: #348EF6;
    margin-right: 0.5rem;
  }
  & .action.toast-action-text {
    color: #257ADC !important;
  }
  & .custom-toast__loading-url {
    color: #257ADC;
    font-weight: normal;
    text-transform: capitalize;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
